import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches all treatments for a patient. Filter client-side by treatmentType as needed. */
export function useListPatientTreatments(patientId: string) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient-treatments', patientId],
    queryFn: async () => {
      const response = await api.get('/patients/:patientId/treatments', { params: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.treatments
    },
  })
}
